import React, { Component } from 'react';
import PropTypes from 'prop-types';

const classNames = require('classnames');

class IconGeneric extends Component {
  render() {
    const nameClass = `icon--${this.props.name}`;
    const colorClass =
      undefined !== this.props.color ? `icon__${this.props.color}` : '';

    const sizeClass =
      undefined !== this.props.size ? `icon__${this.props.size}` : '';

    const iconClassName = classNames('icon', nameClass, colorClass, sizeClass);

    if (this.props.name === 'twin-beds') {
      return (
        <span>
          <i className="icon icon--single-bed" title={this.props.title} />
          <span className="icon--counter">2 </span>
        </span>
      );
    }

    return <i className={iconClassName} title={this.props.title} />;
  }
}

IconGeneric.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string
};

export default IconGeneric;
